import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';


@Component({
  selector: 'app-pages-scanned',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './pages-scanned.component.html',
  styleUrl: './pages-scanned.component.css'
})
export class PagesScannedComponent {
  @Input() pagesScannedData: string[] = [];

}
